import React, { useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import InputLabel from '@material-ui/core/InputLabel'
import {Dialog,Button,FormLabel} from '@material-ui/core'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'
import * as Comp from '../../';

const initial = {
    label: '',
    description: '',
    instructions: '',
    help: '',
    status: 'ACTIVE',
    type: '',
    tag: [],
    trainingLink: ''
}

const AddDialog = props => {
  const [newItem, setNewItem] = useState(initial)
  const { addHandler } = props
  const [open, setOpen] = React.useState(false)

  const [switchState, setSwitchState] = React.useState({
    addMultiple: false,
  })

  const handleSwitchChange = name => event => {
    setSwitchState({ ...switchState, [name]: event.target.checked })
  }

  const resetSwitch = () => {
    setSwitchState({ addMultiple: false })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    resetSwitch()
  }

  const handleAdd = event => {
    addHandler(newItem)
    setNewItem(initial)
    switchState.addMultiple ? setOpen(true) : setOpen(false)
  }

    const handleChange = name => ({ target: { value } }) => {
        setNewItem({ ...newItem, [name]: value })
    }
    const onTagsChanged = (tags) => {
        setNewItem({ ...newItem, tag: tags });
    };

  const validate = () => {
    if (newItem.label && newItem.description && newItem.instructions && newItem.type) {
      return false;
    } else {
      return true;
    }
  }

  return (
    <div>
      <Tooltip title="Add">
        <IconButton aria-label="add" onClick={handleClickOpen}>
            <AddIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Survey</DialogTitle>
        <DialogContent>
            <DialogContentText>Add new survey.</DialogContentText>
            <TextField
                autoFocus
                margin="dense"
                label="Label"
                helperText="Add a label to distinguish your survey here"
                type="text"
                fullWidth
                value={newItem.label}
                onChange={handleChange('label')}
            />
            <TextField
                margin="dense"
                label="Description"
                placeholder="Enter a description for the survey here"
                helperText="Enter a description for the survey here"
                type="text"
                multiline
                fullWidth
                value={newItem.description}
                onChange={handleChange('description')}
            />
            <TextField
                margin="dense"
                label="Instructions"
                type="text"
                placeholder="Add instructions for the survey here"
                helperText="Add instructions for the survey here"
                multiline
                fullWidth
                value={newItem.instructions}
                onChange={handleChange('instructions')}
            />
            <TextField
                margin="dense"
                label="Help"
                placeholder="Add help guide for the survey here"
                helperText="Add help guide for the survey here"
                type="text"
                multiline
                fullWidth
                value={newItem.help}
                onChange={handleChange('help')}
            />
            <TextField
                margin="dense"
                label="Training Link"
                placeholder="Add a training link for the survey here"
                helperText="Add a training link for the survey here"
                type="text"
                multiline
                fullWidth
                value={newItem.trainingLink}
                onChange={handleChange('trainingLink')}
            />
            <InputLabel className="mt-4" id="suvey-type-label">Type</InputLabel>
            <Select
                labelId="survey-type-label"
                id="survey-type"
                fullWidth
                displayEmpty
                value={newItem.type}
                onChange={handleChange('type')}
            >
                <MenuItem value="">
                <em>None</em>
                </MenuItem>
                <MenuItem value={'CLASSIC'}>Classic</MenuItem>
                <MenuItem value={'CAT'}>Cat</MenuItem>
            </Select>
            <FormHelperText className="mb-4">Add a type for the survey here</FormHelperText>
            <FormLabel>Tags</FormLabel>
            <Comp.General.TagsInput tags={newItem.tag} onTagsChanged={onTagsChanged} />
        </DialogContent>
        <DialogActions>
            <Tooltip title="Add multiple">
                <Switch
                checked={switchState.addMultiple}
                onChange={handleSwitchChange('addMultiple')}
                value="addMultiple"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
            </Tooltip>
            <Button onClick={handleClose} color="primary">
                Cancel
            </Button>
            <Button onClick={handleAdd} color="primary" disabled={validate()}>
                Add
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

AddDialog.propTypes = {
  addHandler: PropTypes.func.isRequired,
}

export default AddDialog
